import Describe from './lib/describe';
import {
    getGiftEventName,
    getBottomTipID,
    getOnClickEventName,
    getPoiContainerID,
} from './lib/eventName';

export default {
    Describe,
    getGiftEventName,
    getBottomTipID,
    getOnClickEventName,
    getPoiContainerID,
};
